import React from 'react';
import {
  AlertOrderContainer,
  AlertOrderHeader,
  AlertOrderIcon,
  AlertOrderMessage,
  AlertOrderTitle,
  AlertOrderType
} from './styles';

interface AlertProps {
  type: AlertOrderType;
  title?: string;
  message: string;
}

const OrderAlert: React.FC<AlertProps> = ({
  type,
  title,
  message,
  children
}) => {
  return (
    <AlertOrderContainer alertType={type}>
      <AlertOrderHeader>
        <AlertOrderIcon>{children}</AlertOrderIcon>
        <AlertOrderTitle>{title && <div>{title}</div>}</AlertOrderTitle>
      </AlertOrderHeader>

      <AlertOrderMessage>{message}</AlertOrderMessage>
    </AlertOrderContainer>
  );
};

export default OrderAlert;
